import { Seo } from '../components/Seo';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';

const TOPICS = ['연애 · 관계', '직장 · 커리어', '사업 · 투자', '취업 · 시험', '이사 · 선택의 갈림길', '올해의 흐름'];

const FLOW = [
  { title: '자리에 앉아 대화를 시작합니다', description: '방문 목적과 오늘의 분위기를 먼저 여쭙습니다. 급하게 카드부터 펼치지 않습니다.' },
  { title: '고민에 맞는 스프레드로 리딩합니다', description: '16년 이상 경력의 리더가 질문을 함께 다듬고, 고민의 결에 맞는 방식으로 카드를 읽습니다.' },
  { title: '칵테일과 함께 이야기가 이어집니다', description: '리딩이 끝나도 대화는 끝나지 않습니다. 카드가 남긴 질문을 안주 삼아 밤이 깊어집니다.' }
];

export function TarotConsultationPage() {
  return (
    <div className="tm-page">
      <Seo
        title="타로 상담 | 타로맨스"
        description="16년 이상 경력의 전문 리더가 진행하는 타로 상담. 타로맨스의 타로 상담은 무료입니다."
      />

      <section className="tm-page-hero">
        <div className="tm-container">
          <Reveal>
            <p className="tm-eyebrow">Tarot Consultation</p>
            <h1 className="tm-display">
              카드 한 장으로 시작하는
              <br />
              <em>깊은 대화</em>
            </h1>
            <p className="tm-lede">
              타로맨스의 타로 상담은 무료입니다. 점을 보러 오는 곳이 아니라, 카드를 매개로 자신의 이야기를 꺼내놓는 자리입니다.
              음주가 어려운 분도 편하게 이용하실 수 있습니다.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="tm-section">
        <div className="tm-container">
          <div className="tm-split">
            <Reveal>
              <div className="tm-split-sticky">
                <p className="tm-eyebrow">How It Works</p>
                <h2 className="tm-h2">상담은 이렇게 진행됩니다</h2>
                <div className="tm-figure tm-figure--tall" style={{ marginTop: 36 }}>
                  <img src="/assets/taromance/stitch-final/tarot-guide.jpg" alt="타로 카드와 칵테일이 놓인 테이블" loading="lazy" />
                </div>
              </div>
            </Reveal>
            <Reveal delay={100}>
              <ol className="tm-steps">
                {FLOW.map((step, index) => (
                  <li className="tm-step" key={step.title}>
                    <span className="tm-step-no">{String(index + 1).padStart(2, '0')}</span>
                    <div>
                      <h3 className="tm-h3">{step.title}</h3>
                      <p className="tm-body-text">{step.description}</p>
                    </div>
                  </li>
                ))}
              </ol>
              <div style={{ marginTop: 48 }}>
                <p className="tm-eyebrow">Topics</p>
                <h3 className="tm-h3" style={{ marginBottom: 20 }}>이런 고민을 가져오세요</h3>
                <div className="tm-trust-facts" style={{ justifyContent: 'flex-start', marginTop: 0 }}>
                  {TOPICS.map((topic) => (
                    <span className="tm-fact-chip" key={topic}>{topic}</span>
                  ))}
                </div>
              </div>
              <div style={{ marginTop: 48 }}>
                <p className="tm-eyebrow">Before You Visit</p>
                <ul className="tm-note-list" style={{ marginTop: 18 }}>
                  <li>타로 상담은 무료로 제공됩니다. 자세한 이용 조건은 방문 시 안내드립니다.</li>
                  <li>상담이 몰리는 시간대에는 대기가 있을 수 있습니다. 예약 방문을 권장합니다.</li>
                  <li>비음주 고객도 논알코올 메뉴와 함께 상담을 이용하실 수 있습니다.</li>
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CtaBand title="오늘의 질문을 들고 오세요. 자리를 준비해 두겠습니다." secondaryLabel="방문 안내" secondaryTo="/visit" />
    </div>
  );
}
